import { createContext } from 'react';

type JobContextType = {
  variables: any;
  query: any;
};

const initialValues = {
  variables: {},
  query: '',
};

export const JobsContext = createContext<JobContextType>(initialValues);
